module.exports = __webpack_public_path__ + "static/media/info.0bfb0413.svg";